import { apiAxios as authAxios } from '../axios.config';

export const getIndicatorRegionalDelegationGroupsCounter = () => {
  return authAxios.get("/api/indicator/regional-delegation-groups/counter");
};

export const getIndicatorCaes = () => {
  return authAxios.get("/api/indicator/cae/counter");
};

export const getIndicatorGenderCounter = () => {
  return authAxios.get("/api/indicator/rep/gender");
};

export const getIndicatorAgeCounter = () => {
  return authAxios.get("/api/indicator/rep/age");
};

export const getIndicatorSchoolQualificationsCounter = () => {
  return authAxios.get("/api/indicator/rep/school-qual");
};

export const getIndicatorQualificationLevelsCounter = () => {
  return authAxios.get("/api/indicator/rep/qual-level");
};

export const getIndicatorStatesCounter = () => {
  return authAxios.get("/api/indicator/status/counter");
};

export const getIndicatorCandidaturesAdCounter = (code, level) => {
  return authAxios.get(`/api/indicator/ad/${encodeURIComponent(code)}/local`, {
    params: { level },
  });
};
export const getIndicatorCandidaturesStatesAdCounter = (code, level) => {
  return authAxios.get(`/api/indicator/ad/${encodeURIComponent(code)}/states`, {
    params: { level },
  });
};
export const getIndicatorCandidaturesGenderAdCounter = (code, level) => {
  return authAxios.get(`/api/indicator/ad/${encodeURIComponent(code)}/gender`, {
    params: { level },
  });
};
export const getIndicatorCandidaturesAgesAdCounter = (code, level) => {
  return authAxios.get(`/api/indicator/ad/${encodeURIComponent(code)}/ages`, {
    params: { level },
  });
};
export const getIndicatorCandidaturesSchoolQualificationAdCounter = (code, level) => {
  return authAxios.get(`/api/indicator/ad/${encodeURIComponent(code)}/school-qual`, {
    params: { level },
  });
};
export const getIndicatorCandidaturesQualificationLevelsAdCounter = (code, level) => {
  return authAxios.get(`/api/indicator/ad/${encodeURIComponent(code)}/qual-level`, {
    params: { level },
  });
};

export const getIndicatorPayments = () => {
  return authAxios.get("/api/indicator/payments");
};

export const getIndicatorRestitutions = () => {
  return authAxios.get("/api/indicator/noncompliance/restitutions");
};

export const getIndicatorCandidatureChangesByType = (code) => {
  return authAxios.get("/api/indicator/changes/type",code ? { params: {code:code} } : null);
};

export const getIndicatorCandidatureChangesByState = (code) => {
  return authAxios.get("/api/indicator/changes/state",code ? { params: {code:code} } : null);
};

export const getIndicatorPriorSupport = (code) => {
  return authAxios.get("/api/indicator/prior-support");
};

export const getIndicatorOpinionSupport = (index,size,nif,regionalDelegationCode) => {
  return authAxios.get('/api/indicator/opinion-support');
};

export const getIndicatorSupportMceSummaryByEa = (code) => {
  return authAxios.get('/api/indicator/supportMceByEaSummary', {
    params: { code },
  });
};

export const getIndicatorSupportMceSummaryByRegionalDelegation = (code) => {
  return authAxios.get('/api/indicator/supportMceByRegionalSummary', {
    params: { code },
  });
};

export const getIndicatorComplementaryAmounts = () =>
  authAxios.get("/api/indicator/complementary-amounts");

export const getIndicatorComplementaryActivitiesStates = () =>
  authAxios.get("/api/indicator/complementary-states");

export const getIndicatorAdvancePayments = () =>
  authAxios.get("/api/indicator/advance-payments");




















